/* eslint-disable */

<template>
  <div>
    <div class="vx-row">

      <div class="vx-col lg:w-4/12 md:w-5/12 sm:w-5/5 mb-4">
        <div class="flex gap-2 mb-2">
          <vs-button :color="sel==='r1'?'primary':'grey'" type="filled" class="flex-1" @click="sel='r1'">R1</vs-button>
          <vs-button :color="sel==='r2'?'primary':'grey'" type="filled" class="flex-1" @click="sel='r2'">R2</vs-button>
        </div>

        <vx-card style="height: 42rem; overflow-y: auto">

          <!-- Task 1 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task1Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task1Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task1Done?'#28C76F':'#4a5568'}">1</span>
              <span class="font-semibold text-sm flex-1">Assign IPv4 addresses — subnet 10.0.12.4/30</span>
              <span class="text-xs font-medium" :class="task1Done?'text-success':'text-grey'">{{ task1Progress }}/7</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">R1</span>
              <div class="space-y-1 ml-1 mb-2">
                <div v-for="item in task1R1Items" :key="'t1-r1-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r1Completion[item.key])"></div>
                  <code class="text-base" :class="r1Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">R2</span>
              <div class="space-y-1 ml-1 mb-2">
                <div v-for="item in task1R2Items" :key="'t1-r2-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r2Completion[item.key])"></div>
                  <code class="text-base" :class="r2Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">Verify — R1</span>
              <div class="space-y-1 ml-1">
                <div class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r1Completion.pingV4)"></div>
                  <code class="text-base" :class="r1Completion.pingV4?'text-success':''">ping 10.0.12.6</code>
                </div>
              </div>
            </div>
          </div>

          <!-- Task 2 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task2Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task2Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task2Done?'#28C76F':'#4a5568'}">2</span>
              <span class="font-semibold text-sm flex-1">Assign IPv6 addresses — prefix 2001:db8:12::/126</span>
              <span class="text-xs font-medium" :class="task2Done?'text-success':'text-grey'">{{ task2Progress }}/5</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">R1</span>
              <div class="space-y-1 ml-1 mb-2">
                <div v-for="item in task2R1Items" :key="'t2-r1-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r1Completion[item.key])"></div>
                  <code class="text-base" :class="r1Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">R2</span>
              <div class="space-y-1 ml-1 mb-2">
                <div v-for="item in task2R2Items" :key="'t2-r2-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r2Completion[item.key])"></div>
                  <code class="text-base" :class="r2Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">Verify — R1</span>
              <div class="space-y-1 ml-1">
                <div class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r1Completion.pingV6)"></div>
                  <code class="text-base" :class="r1Completion.pingV6?'text-success':''">ping 2001:db8:12::3</code>
                </div>
              </div>
            </div>
          </div>

          <!-- Save -->
          <div class="rounded-lg mb-2 overflow-hidden" :style="{border:'1px solid '+(saveDone?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:saveDone?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <feather-icon :icon="saveDone?'CheckCircleIcon':'CircleIcon'" :svgClasses="saveDone?'text-success':'text-grey'" size="16" class="flex-shrink-0" />
              <span class="font-semibold text-sm flex-1">Save Configuration</span>
              <span class="text-xs font-medium" :class="saveDone?'text-success':'text-grey'">{{ [r1Completion.saved,r2Completion.saved].filter(Boolean).length }}/2</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="rk in ['r1','r2']" :key="'s-'+rk" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ rk.toUpperCase() }}</span>
                <div class="space-y-1 ml-1">
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot(getComp(rk).saved)"></div>
                    <code class="text-base" :class="getComp(rk).saved?'text-success':''">copy running-config startup-config</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </vx-card>
      </div>

      <div class="vx-col lg:w-8/12 md:w-7/12 sm:w-5/5">
        <div style="height: 35rem">
          <vue-command v-show="sel==='r1'" key="r1" id="r1_terminal" :commands="r1Commands" :prompt="r1Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="R1" />
          <vue-command v-show="sel==='r2'" key="r2" id="r2_terminal" :commands="r2Commands" :prompt="r2Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="R2" />
        </div>

        <!-- Topology -->
        <div class="topology-card">
          <img :src="topologyImage" alt="Network topology" class="topology-img" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VueCommand, { createStdout, createStderr } from 'vue-command';
import 'vue-command/dist/vue-command.css';

const HELP = 'Type commands as shown in the task checklist. Use "end" to reach exec mode, then "ping" to verify connectivity.';

const mkCommands = (rk, vm) => ({
  help:       () => createStdout(HELP),
  enable:     () => vm.iosEnable(rk),
  configure:  (x) => vm.iosConfigure(rk, x),
  conf:       (x) => vm.iosConfigure(rk, x),
  interface:  (x) => vm.iosInterface(rk, x),
  int:        (x) => vm.iosInterface(rk, x),
  ip:         (x) => vm.iosIp(rk, x),
  ipv6:       (x) => vm.iosIpv6(rk, x),
  no:         (x) => vm.iosNo(rk, x),
  ping:       (x) => vm.iosPing(rk, x),
  exit:       () => vm.iosExit(rk),
  end:        () => vm.iosEnd(rk),
  copy:       (x) => vm.iosCopy(rk, x),
});

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      topologyImage: 'https://ip-learn.b-cdn.net/simulations/ccna-topologies/IPv4_and_IPv6_Connectivity_Sim.png',
      sel: 'r1',
      totalScore: 0,

      r1: { mode: 'exec', currentIf: null },
      r2: { mode: 'exec', currentIf: null },

      // r1: task1(4) + task2(3) + saved(1) = 8
      r1Completion: {
        e00IfT1: false, e00Ipv4: false, e00NoShut: false, pingV4: false,
        e00IfT2: false, e00Ipv6: false, pingV6: false,
        saved: false,
      },
      // r2: task1(3) + task2(2) + saved(1) = 6
      r2Completion: {
        e00IfT1: false, e00Ipv4: false, e00NoShut: false,
        e00IfT2: false, e00Ipv6: false,
        saved: false,
      },

      r1Commands: null,
      r2Commands: null,

      task1R1Items: [
        { key: 'e00IfT1',   label: 'interface e0/0' },
        { key: 'e00Ipv4',   label: 'ip address 10.0.12.5 255.255.255.252' },
        { key: 'e00NoShut', label: 'no shut' },
      ],
      task1R2Items: [
        { key: 'e00IfT1',   label: 'interface e0/0' },
        { key: 'e00Ipv4',   label: 'ip address 10.0.12.6 255.255.255.252' },
        { key: 'e00NoShut', label: 'no shut' },
      ],
      task2R1Items: [
        { key: 'e00IfT2',   label: 'interface e0/0' },
        { key: 'e00Ipv6',   label: 'ipv6 address 2001:db8:12::1/126' },
      ],
      task2R2Items: [
        { key: 'e00IfT2',   label: 'interface e0/0' },
        { key: 'e00Ipv6',   label: 'ipv6 address 2001:db8:12::3/126' },
      ],
    };
  },

  computed: {
    r1Prompt() {
      const m = this.r1.mode;
      if (m === 'config-if') return 'R1(config-if)#';
      if (m === 'config')    return 'R1(config)#';
      return 'R1#';
    },
    r2Prompt() {
      const m = this.r2.mode;
      if (m === 'config-if') return 'R2(config-if)#';
      if (m === 'config')    return 'R2(config)#';
      return 'R2#';
    },

    // task1: r1(4) + r2(3) = 7
    task1Progress() {
      const c1 = this.r1Completion, c2 = this.r2Completion;
      return [c1.e00IfT1, c1.e00Ipv4, c1.e00NoShut, c1.pingV4,
              c2.e00IfT1, c2.e00Ipv4, c2.e00NoShut].filter(Boolean).length;
    },
    task1Done() { return this.task1Progress === 7; },

    // task2: r1(3) + r2(2) = 5
    task2Progress() {
      const c1 = this.r1Completion, c2 = this.r2Completion;
      return [c1.e00IfT2, c1.e00Ipv6, c1.pingV6,
              c2.e00IfT2, c2.e00Ipv6].filter(Boolean).length;
    },
    task2Done() { return this.task2Progress === 5; },

    saveDone() { return this.r1Completion.saved && this.r2Completion.saved; },
  },

  mounted() {
    this.dataLocal.options.showMarkButton = false;
    this.$emit('simulation_update_options', this.dataLocal);
    this.r1Commands = mkCommands('r1', this);
    this.r2Commands = mkCommands('r2', this);
  },

  methods: {
    getComp(k) { return this[k + 'Completion']; },

    dot(val) {
      return { width: '8px', height: '8px', background: val ? '#28C76F' : 'transparent', border: '2px solid ' + (val ? '#28C76F' : '#6b7280') };
    },

    guide(msg) {
      return `<span style="color:#28C76F;display:block;margin-top:6px;padding:4px 8px;border-left:2px solid #28C76F;font-size:0.85em;line-height:1.5">${msg}</span>`;
    },

    normalizeIf(ifStr) {
      return (ifStr || '').toLowerCase()
        .replace(/^gigabitethernet/, '')
        .replace(/^fastethernet/, '')
        .replace(/^ethernet/, '')
        .replace(/^gi(?=\d)/, '')
        .replace(/^fa(?=\d)/, '')
        .replace(/^e(?=\d)/, '')
        .replace(/^g(?=\d)/, '')
        .trim();
    },

    updateScore() {
      let score = 0;
      [this.r1Completion, this.r2Completion].forEach(c =>
        Object.values(c).forEach(v => { if (v) score++; })
      );
      this.totalScore = score;
      this.$forceUpdate();
      this.$emit('simulation_update_score', score);
      // r1(8) + r2(6) = 14
      if (score >= 14) setTimeout(() => this.$emit('simulation_full_correct', score), 500);
    },

    iosEnable(rk) {
      this[rk].mode = 'exec';
      return createStdout('');
    },

    iosConfigure(rk, x) {
      const s = this[rk];
      if (s.mode !== 'exec') return createStderr('% Already in configuration mode — type "end" to return to exec first');
      if (x._[1] === 'terminal' || x._[1] === 't') {
        s.mode = 'config';
        return createStdout('Enter configuration commands, one per line.  End with CNTL/Z.');
      }
      return createStderr('% Invalid input detected');
    },

    iosExit(rk) {
      const s = this[rk];
      if (s.mode === 'config-if') {
        s.mode = 'config';
        s.currentIf = null;
      } else if (s.mode === 'config') {
        s.mode = 'exec';
      }
      return createStdout('');
    },

    iosEnd(rk) {
      this[rk].mode = 'exec';
      this[rk].currentIf = null;
      return createStdout('');
    },

    iosInterface(rk, x) {
      const s = this[rk];
      if (s.mode !== 'config') return createStderr('% Invalid input detected — must be in global configuration mode');
      let ifArg = String(x._[1] || '');
      if (x._[2] && /^\d+\/\d+/.test(String(x._[2]))) ifArg = ifArg + x._[2];
      const ifNorm = this.normalizeIf(ifArg);

      s.mode = 'config-if';
      s.currentIf = ifNorm;

      const c = this[rk + 'Completion'];
      if (ifNorm === '0/0') {
        if (!c.e00IfT1)      { c.e00IfT1 = true; this.updateScore(); }
        else if (!c.e00IfT2) { c.e00IfT2 = true; this.updateScore(); }
      }

      return createStdout('');
    },

    iosIp(rk, x) {
      const s = this[rk];
      if (s.mode !== 'config-if') return createStderr('% Invalid input detected — must be in interface configuration mode');
      if ((x._[1] || '').toLowerCase() !== 'address') return createStderr('% Invalid input detected');

      const ip   = (x._[2] || '');
      const mask = (x._[3] || '');
      const c    = this[rk + 'Completion'];

      if (s.currentIf === '0/0' && !c.e00Ipv4) {
        if (rk === 'r1' && ip === '10.0.12.5' && mask === '255.255.255.252') {
          c.e00Ipv4 = true; this.updateScore();
          return createStdout(this.guide(
            'IPv4 10.0.12.5/30 assigned to R1 e0/0. In the 10.0.12.4/30 subnet the usable range is 10.0.12.5–10.0.12.6 — just 2 hosts. ' +
            'A /30 (255.255.255.252) is the standard choice for point-to-point router links: no wasted addresses beyond network and broadcast. ' +
            '→ "no shut" to bring the interface up.'
          ));
        }
        if (rk === 'r2' && ip === '10.0.12.6' && mask === '255.255.255.252') {
          c.e00Ipv4 = true; this.updateScore();
          return createStdout(this.guide(
            'IPv4 10.0.12.6/30 assigned to R2 e0/0. This is the last usable host address — 10.0.12.7 is the broadcast address and cannot be assigned to a host. ' +
            '→ "no shut" to bring the interface up.'
          ));
        }
      }

      return createStdout('');
    },

    iosIpv6(rk, x) {
      const s = this[rk];
      if (s.mode !== 'config-if') return createStderr('% Invalid input detected — must be in interface configuration mode');
      if ((x._[1] || '').toLowerCase() !== 'address') return createStderr('% Invalid input detected');

      const addr = (x._[2] || '').toLowerCase();
      const c    = this[rk + 'Completion'];

      if (s.currentIf === '0/0' && !c.e00Ipv6) {
        if (rk === 'r1' && addr === '2001:db8:12::1/126') {
          c.e00Ipv6 = true; this.updateScore();
          return createStdout(this.guide(
            'IPv6 2001:db8:12::1/126 assigned to R1. The /126 prefix gives 2²=4 addresses: ::0 is the subnet router anycast address (reserved, do not assign), ::1–::3 are usable host addresses. ' +
            'IPv6 has NO broadcast address — all three remaining addresses are valid for hosts. ' +
            '→ Configure R2\'s IPv6 address, then ping to verify.'
          ));
        }
        if (rk === 'r2' && addr === '2001:db8:12::3/126') {
          c.e00Ipv6 = true; this.updateScore();
          return createStdout(this.guide(
            'IPv6 2001:db8:12::3/126 assigned to R2. This is the last address in the subnet — valid because IPv6 reserves no broadcast address, so ::3 is fully usable (unlike IPv4 where the last address is broadcast). ' +
            '→ From R1\'s exec mode: "ping 2001:db8:12::3" to verify connectivity.'
          ));
        }
      }

      return createStdout('');
    },

    iosNo(rk, x) {
      const s = this[rk];
      if (s.mode !== 'config-if') return createStderr('% Invalid input detected — must be in interface configuration mode');
      const sub1 = (x._[1] || '').toLowerCase();
      const c    = this[rk + 'Completion'];

      if ((sub1 === 'shut' || sub1 === 'shutdown') && s.currentIf === '0/0' && !c.e00NoShut) {
        c.e00NoShut = true; this.updateScore();
        return createStdout(
          `%LINEPROTO-5-UPDOWN: Line protocol on Interface GigabitEthernet0/0, changed state to up` +
          this.guide(
            `${rk.toUpperCase()} e0/0 is now up. Router interfaces default to administratively shutdown — unlike switch ports, they must be explicitly enabled with "no shutdown". ` +
            (rk === 'r1' && this.r2Completion.e00NoShut
              ? '→ Type "end" then "ping 10.0.12.6" to verify IPv4 connectivity.'
              : rk === 'r1'
                ? '→ Configure R2\'s IPv4 address and bring up its interface, then ping from R1.'
                : '→ From R1\'s exec mode: "end" then "ping 10.0.12.6" to verify connectivity.')
          )
        );
      }

      return createStdout('');
    },

    iosPing(rk, x) {
      const s = this[rk];
      if (s.mode !== 'exec') return createStderr('% Must be in privileged EXEC mode — type "end" first');

      const target = (x._[1] || '').toLowerCase();
      const c      = this[rk + 'Completion'];

      // IPv4 ping
      if (target === '10.0.12.6') {
        const ready = this.r1Completion.e00Ipv4 && this.r1Completion.e00NoShut &&
                      this.r2Completion.e00Ipv4 && this.r2Completion.e00NoShut;
        if (!ready) {
          return createStdout(
            'Type escape sequence to abort.<br>' +
            'Sending 5, 100-byte ICMP Echos to 10.0.12.6, timeout is 2 seconds:<br>' +
            '.....<br>' +
            'Success rate is 0 percent (0/5)' +
            this.guide('Ping failed — ensure both R1 and R2 have their IPv4 addresses configured and interfaces brought up with "no shut".')
          );
        }
        const out =
          'Type escape sequence to abort.<br>' +
          'Sending 5, 100-byte ICMP Echos to 10.0.12.6, timeout is 2 seconds:<br>' +
          '.!!!!</b><br>' +
          'Success rate is 80 percent (4/5), round-trip min/avg/max = 1/2/4 ms';
        if (rk === 'r1' && !c.pingV4) {
          c.pingV4 = true; this.updateScore();
          return createStdout(out + this.guide(
            'Ping to R2 successful. The leading "." is normal — the first packet triggers ARP resolution for R2\'s MAC address; the four "!" are successful ICMP echo replies. ' +
            '→ Configure IPv6: "configure terminal" then "interface e0/0" then "ipv6 address 2001:db8:12::1/126".'
          ));
        }
        return createStdout(out);
      }

      // IPv6 ping
      if (target === '2001:db8:12::3') {
        const ready = this.r1Completion.e00Ipv6 && this.r2Completion.e00Ipv6;
        if (!ready) {
          return createStdout(
            'Type escape sequence to abort.<br>' +
            'Sending 5, 100-byte ICMP Echos to 2001:DB8:12::3, timeout is 2 seconds:<br>' +
            '.....<br>' +
            'Success rate is 0 percent (0/5)' +
            this.guide('Ping failed — ensure both R1 and R2 have their IPv6 addresses configured.')
          );
        }
        const out =
          'Type escape sequence to abort.<br>' +
          'Sending 5, 100-byte ICMP Echos to 2001:DB8:12::3, timeout is 2 seconds:<br>' +
          '!!!!!</b><br>' +
          'Success rate is 100 percent (5/5), round-trip min/avg/max = 1/2/4 ms';
        if (rk === 'r1' && !c.pingV6) {
          c.pingV6 = true; this.updateScore();
          return createStdout(out + this.guide(
            'IPv6 ping to R2 successful — 100% (!!!!!). IPv6 uses NDP (Neighbor Discovery Protocol) instead of ARP; NDP resolves link-layer addresses inline in the first packet so all 5 succeed. ' +
            '→ Save both routers: "copy running-config startup-config" (type "end" first).'
          ));
        }
        return createStdout(out);
      }

      return createStdout(
        'Type escape sequence to abort.<br>' +
        `Sending 5, 100-byte ICMP Echos to ${x._[1]}, timeout is 2 seconds:<br>` +
        '.....<br>' +
        'Success rate is 0 percent (0/5)'
      );
    },

    iosCopy(rk, x) {
      const s = this[rk];
      if (s.mode !== 'exec') return createStderr('% Must be in privileged EXEC mode — type "end" first');
      const c = this[rk + 'Completion'];
      if (x._[1] === 'running-config' && x._[2] === 'startup-config') {
        if (!c.saved) { c.saved = true; this.updateScore(); }
        return createStdout(
          'Destination filename [startup-config]?<br>Building configuration...<br>[OK]' +
          this.guide(
            `${rk.toUpperCase()} configuration saved to NVRAM. ` +
            (this.saveDone ? '✓ Both routers saved — simulation complete!' : '→ Save the remaining router.')
          )
        );
      }
      return createStderr('% Invalid input detected');
    },
  },

  components: { VueCommand },
  props: { data: { type: Object, required: true } },
};
</script>

<style>
#r1_terminal, #r2_terminal { overflow: hidden !important; }

.topology-card {
  margin-top: 1.5rem;
  background-color: #111111;
  border: 1px solid #181d2a;
  border-radius: 0.5rem;
  overflow: hidden;
  line-height: 0;
}
.topology-img {
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
}
</style>

